import { Component, Input, TemplateRef } from '@angular/core';
import { BaseComponent } from './base.component';

@Component({
    selector: 'prox-main',
    templateUrl: './prox-main.component.html',
    standalone: false
})
export class ProxMainComponent  {
  @Input() parent?: BaseComponent;
  @Input() bodyTemplate?: TemplateRef<any>;
  @Input() footerTemplate?: TemplateRef<any>;
  @Input() showBack?: boolean;
  @Input() isDisabled?: boolean;

  constructor() {
    //
  }
}
